module.exports = __webpack_public_path__ + "static/img/bg-overview@t.5137469.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/project-detail/xeogen/bg-overview@t.jpg
// module id = 6Tq+
// module chunks = 0